import type { NavigateFunction } from "react-router-dom";
import { PAGE_ROUTES } from "./constants";
import { gaWorkWithUsClick } from "./ga4";

let lastTrackedAt = 0;
const DEDUPE_MS = 300;

/** True for relative or absolute URLs that navigate to the Work With Us page. */
export function isWorkWithUsHref(href: string | null | undefined): boolean {
  if (!href) return false;
  const trimmed = href.trim();
  if (!trimmed) return false;

  try {
    if (/^https?:\/\//i.test(trimmed)) {
      const { pathname } = new URL(trimmed);
      return (
        pathname === PAGE_ROUTES.WORK_WITH_US ||
        pathname.endsWith(PAGE_ROUTES.WORK_WITH_US)
      );
    }
    const path = trimmed.split("?")[0].split("#")[0];
    return path === PAGE_ROUTES.WORK_WITH_US || path.endsWith(PAGE_ROUTES.WORK_WITH_US);
  } catch {
    return trimmed.includes(PAGE_ROUTES.WORK_WITH_US);
  }
}

const NAV_DELAY_MS = 150;

/** Meta custom event + GA4 event for Work With Us CTA clicks (before navigation). */
export function trackWorkWithUsClick() {
  const now = Date.now();
  if (now - lastTrackedAt < DEDUPE_MS) return;
  lastTrackedAt = now;

  if (typeof window.fbq === "function") {
    window.fbq("trackCustom", "WorkWithUsClick");
  }
  gaWorkWithUsClick();
}

/** Track click, then navigate to /work-with-us (use for buttons — not RouterLink). */
export function navigateToWorkWithUs(navigate: NavigateFunction) {
  trackWorkWithUsClick();
  // Brief delay so Meta/GA beacons enqueue before the SPA route changes.
  window.setTimeout(() => navigate(PAGE_ROUTES.WORK_WITH_US), NAV_DELAY_MS);
}

export function trackWorkWithUsClickIfHref(href: string | null | undefined) {
  if (isWorkWithUsHref(href)) trackWorkWithUsClick();
}

/** Track click before full-page navigation (e.g. gallery header). */
export function goToWorkWithUsUrl(url: string) {
  if (isWorkWithUsHref(url)) trackWorkWithUsClick();
  window.setTimeout(() => window.location.assign(url), isWorkWithUsHref(url) ? NAV_DELAY_MS : 0);
}
